import { HttpClient } from "@angular/common/http";
import { AfterViewInit, Component, OnDestroy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { Config } from "../../config.const";

@Component({
    selector: 'app-domande-appuntamento',
    styleUrls: ['./domande-appuntamento.css'],
    templateUrl: './domande-appuntamento.html'
})
export class DomandeAppuntamentoComponent implements AfterViewInit, OnDestroy {
    subArray: Subscription[] = []
    domande = []
    errore = ''

    constructor(private http: HttpClient, public activeModal: NgbActiveModal) {
    }




    ngAfterViewInit() {
        this.load()
    }





    save() {

        if (this.domande.find(d => d.testo.replaceAll(' ', '') === '')) {
            this.errore = 'Attenzione, alcune domande sono vuote'
            return
        }

        this.subArray.push(
            this.http.post(`${Config.baseURL}/impostazioni/domande-appuntamento`, { domande: this.domande }).subscribe(response => {
                this.activeModal.close()
            })
        )
    }




    load() {
        this.subArray.push(
            this.http.get(`${Config.baseURL}/impostazioni/domande-appuntamento`).subscribe(response => {
                this.domande = (response as any[])
            })
        )
    }





    add(nuovaDomanda) {
        this.domande.push({ id: 0, testo: nuovaDomanda.value })
    }






    del(domanda) {
        this.domande = this.domande.filter(d => d !== domanda)
    }






    ngOnDestroy(): void {
        this.subArray.forEach(s => s.unsubscribe())
    }
}


// WEBPACK FOOTER //
// ./src/app/opzioni/domande-appuntamento/domande-appuntamento.ts